module.exports = __webpack_public_path__ + "img/message-circle.8a8c7ec3.svg";